module.exports = __webpack_public_path__ + "assets/img/42.c05105d2.jpg";